import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db } from "firebase/fbConfig.js"

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import loader from "assets/img/loader.gif";
import miniLoading from "assets/img/simple_loading.gif";
import DescriptionIcon from '@material-ui/icons/Description';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Search from "@material-ui/icons/Search";
import Accordion from "components/Accordion/Accordion.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
// import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";
import Style from 'assets/jss/material-dashboard-pro-react/views/threadsStyle.jsx';
import { Grid } from "@material-ui/core";

import ThreadsMap from "./ThreadsMap"
// Forms
import CreateMessageForm from "../../../components/Forms/CreateMessageForm";
import CreateClientThreadsMessageForm from 'components/Forms/CreateClientThreadsMessageForm';

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Threads extends React.Component {

  render() {
    const { classes, currentThread } = this.props;
    //console.log(users)
    const searchButton =
      classes.top +
      " " +
      classes.searchButton;
    return (
      <div>
        <GridContainer style={{ width: "100%", margin: "0 -6px" }}>
          <GridItem className={classes.threadsGrid} xs={12} sm={12} md={11}>
            <ThreadsMap />

            <div>
              <div className={classes.documents}>
                {currentThread &&
                  currentThread.documents &&
                  currentThread.documents.map((document, index) => (
                    <a key={index} href={document.url} target='_blank'>
                      <span className={classes.documentName}>
                        {document.name}</span> <br />
                      <Button
                        color='primary'
                        style={{
                          marginLeft: '10px',
                          marginBottom: '10px',
                        }}
                      >
                        <DescriptionIcon></DescriptionIcon>
                      </Button>
                    </a>
                  ))}
              </div>
              <CreateClientThreadsMessageForm />
            </div>
          </GridItem>

        </GridContainer>
      </div>
    );

  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentThread: state.threads.currentThread,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(Threads);
